import { render, staticRenderFns } from "./MarketingSalesDetailChannel.vue?vue&type=template&id=c3a751e4&"
import script from "./MarketingSalesDetailChannel.vue?vue&type=script&lang=js&"
export * from "./MarketingSalesDetailChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports